import template from './cheatsheet.html';

class CheatSheetViewModel
{
	constructor (page)
	{
		this.page = page;
		this.bindings = page.bindings;
		this.loaded = ko.observable(false);
	}

	setupStaticPageInteractions()
	{
		const root = this.page.element;
		const sections = Array.from(root.querySelectorAll('.cheatsheet-section'));
		const navItems = Array.from(root.querySelectorAll('[data-nav-for]'));
		const navLinks = Array.from(root.querySelectorAll('[data-scroll-target]'));

		const scrollToSection = (targetId) => {
			const section = root.querySelector(`#${targetId}`);
			if (!section)
				return;

			const offset = 80;
			const top = section.getBoundingClientRect().top + window.pageYOffset - offset;
			window.scrollTo({ top, behavior: 'smooth' });
		};

		const updateActiveNav = () => {
			const anchor = window.innerHeight * 0.3;
			let activeSectionId = sections[0] ? sections[0].id : null;

			sections.forEach(section => {
				const top = section.getBoundingClientRect().top;
				if (top <= anchor)
					activeSectionId = section.id;
			});

			navItems.forEach(item => {
				const target = item.getAttribute('data-nav-for');
				item.classList.toggle('active', target === activeSectionId);
			});
		};

		navLinks.forEach(link => {
			link.addEventListener('click', (event) => {
				event.preventDefault();
				const targetId = link.getAttribute('data-scroll-target');
				if (targetId)
					scrollToSection(targetId);
			});
		});

		this.setupAccordions(root);

		window.addEventListener('scroll', updateActiveNav, { passive: true });
		updateActiveNav();
	}

	setupAccordions(root)
	{
		const accordions = root.querySelectorAll('.cheatsheet-accordion');
		accordions.forEach(accordion => {
			const labels = accordion.querySelectorAll('article > label');
			labels.forEach(label => {
				label.addEventListener('click', () => {
					label.classList.toggle('selected');
				});
			});
		});
	}
}

class CheatSheetPageClass
{
	constructor (bindings, element)
	{   
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new CheatSheetViewModel(this);
		document.title = 'UI-PS Cheat Sheet';
		Grape.BreadCrumb.push({ default_route: {'CheatSheet':'/ui/cheatsheet'} }); 
	}   

	async init()
	{
		this.viewModel.loaded(true);
		this.viewModel.setupStaticPageInteractions();
	}
}

export default {
	route: '/ui/cheatsheet/',
	page_class: CheatSheetPageClass,
	template: template
}
